<footer class="rek-footer">
  <div class="rek-footer__main-content">
    <div class="row align-items-center m-0">
      <div class="col-12 d-flex justify-content-center p-0">
        <img [src]="pjaitLogoUrl" class="rek-footer__logo" />
      </div>
      <div class="col-12">
        <ul class="rek-footer__links">
          <li>
            <a [href]="pjaitWebsiteUrl" class="rek-footer__link" target="_blank">
              {{ 'HOME.ROOT.FOOTER.UNIVERSITY-WEBSITE' | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="AppPaths.Home.Contact.StringPath" class="rek-footer__link">
              {{ AppPaths.Home.Contact.PageData.Title | translate}}
            </a>
          </li>
          <li>
            <a [routerLink]="AppPaths.Home.RulesWarsaw.StringPath" class="rek-footer__link">
              {{ AppPaths.Home.RulesWarsaw.PageData.Title | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="AppPaths.Home.RulesGdansk.StringPath" class="rek-footer__link">
              {{ AppPaths.Home.RulesGdansk.PageData.Title | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
